import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=97862f2c&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\xampp\\htdocs\\app.poojalab.com\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97862f2c')) {
      api.createRecord('97862f2c', component.options)
    } else {
      api.reload('97862f2c', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=97862f2c&", function () {
      api.rerender('97862f2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/announcement/detail.vue"
export default component.exports